<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="alert-group" v-show="alerts.length > 0">
    <transition-group name="fade">
      <div v-for="alert in alerts" :key="alert.key">
        <v-alert
          :type="alert.type"
          :border="alert.border"
          :color="alert.color"
          :colored-border="alert.coloredBorder"
          :dense="alert.dense"
          :text="alert.text"
          :icon="alert.icon"
        >
          <span v-html="alert.content" />
          <v-btn
            v-if="!alert.hideCloseBtn"
            icon
            small
            @click.stop="remove(alert.key)"
          >
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-alert>
      </div>
    </transition-group>
  </div>
</template>

<script>
import * as suuid from 'short-uuid'
/**
 *
 */
export default {
  data () {
    return {
      alerts: [],
      alertMap: {},
      i: 0,
      key: ''
    }
  },
  mounted () {
    this.key = suuid.generate()
    this.$showAlert = (opts) => {
      this.addAlert(this.parseOptions(opts))
    }
    this.$closeAlert = (opts) => {
      if (opts) {
        if (typeof opts === 'string') {
          this.remove(opts)
        } else if (typeof opts === 'object') {
          this.remove(opts.key)
        }
      }
    }
    this.$bus.$on('show-alert', this.$showAlert)
    this.$bus.$on('close-alert', this.$closeAlert)
  },
  beforeDestroy () {
    this.$bus.$off('show-alert', this.$showAlert)
    this.$bus.$off('close-alert', this.$closeAlert)
  },
  methods: {
    generateKey () {
      this.i += 1
      return `${this.key}-${this.i}`
    },
    parseOptions (alert) {
      if (!alert.key) {
        alert.key = this.generateKey()
      }
      return alert
    },
    addAlert (alert) {
      // 若出現重複的 key 則將之前的移除掉
      if (this.alertMap[alert.key]) {
        this.remove(alert.key)
      }
      this.$nextTick(() => {
        // 自動關閉功能
        if (!alert.timeout) {
          if (alert.timeout === null || alert.timeout === undefined) {
            alert.timeout = 1000
          }
        }
        if (typeof alert.timeout === 'number') {
          alert._timeoutId = setTimeout(() => {
            this.remove(alert.key)
          }, alert.timeout)
        }
        this.alertMap[alert.key] = alert
        this.alerts.push(alert)
      })
    },
    remove (key) {
      const alert = this.alertMap[key]
      if (this.alertMap[key]) {
        delete this.alertMap[key]
        const index = this.alerts.findIndex(item => item.key === key)
        this.alerts.splice(index, 1)
        if (alert._timeoutId) {
          clearTimeout(alert._timeoutId)
        }
      }
    }
  }
}
</script>

<style>
.alert-group {
  position: fixed;
  right: 4px;
  bottom: 4px;
  flex-direction: row-reverse;
  justify-content: flex-end;
}
</style>
